export const LEVELS = [
  {
    title: 'Clinic/HQ',
    value: 'ClinicOrHQ',
    type: 'clinic'
  },
  {
    title: 'Sub-unit',
    value: 'Surgery',
    type: 'clinic'
  },
  {
    title: 'Personal',
    value: 'Personal',
    type: 'personal'
  }
]
export const APPRAISALS_VALUES = {
    CORRECT: 'Correct',
    INCORRECT: 'Incorrect',
    NOT_CHECKED: 'Not checked'
}
export const APPRAISALS = [
  {
    id: 1,
    title: APPRAISALS_VALUES.CORRECT,
    display: true,
    icon: '$happyFace'
  },
  {
    id: 2,
    title: APPRAISALS_VALUES.INCORRECT,
    display: true,
    icon: '$sadFace'
  },
  {
    id: 3,
    title: APPRAISALS_VALUES.NOT_CHECKED,
    display: false,
    icon: ''
  }
]
export const ROTA_STATUSES = {
  working: 'Working',
  off: 'Off',
  spare: 'Spare'
}

export const FILE_ACCEPT_SCANNED_DOCUMENTS =
  '.pdf,.jpg,.jpeg,.png,.webp,.tif,.tiff'

export const TRANSITION_PROGRAMME_FORM_TYPES = [
  'ReferenceConsentAndDetails',
  'BankDetails',
  'NewEmployeeForm',
  'StaffUniformLog',
  'HealthScreeningAndConfidentialRecords',
  'P46EmployeeWithoutP45Accounts',
  'DentistProfile',
  'ProofOfAddress',
  'EmergencyContact',
  'ProfileImage',
  'PassportAndCpdUpload'
]
